import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { ref, get } from "firebase/database";
import { db, requestImovelWatermark } from "../firebaseConfig";

import WaterMark from "../assets/logo_footer.png";

import { useFavorites } from "../Components/Context/FavoritesContext";
import ShareModal from "../Components/ShareModal";

import { IoIosArrowBack, IoIosArrowForward, IoIosClose } from "react-icons/io";

import { IoArrowBackSharp } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import { PiHouseLineFill } from "react-icons/pi";
import { GiBroom, GiTable } from "react-icons/gi";
import { MdOutdoorGrill } from "react-icons/md";

import { FaKitchenSet, FaFaucetDrip } from "react-icons/fa6";

import {
  FaBed,
  FaHouseDamage,
  FaLocationArrow,
  FaBath,
  FaCar,
  FaRegHeart,
  FaHeart,
  FaTv,
  FaBuilding,
  FaDoorClosed,
  FaRulerCombined,
  FaMapMarkedAlt,
  FaWhatsapp,
  FaFileDownload,
  FaShareAlt,
} from "react-icons/fa";

import { RiCheckboxBlankCircleFill } from "react-icons/ri";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../styles/imovel.css";

const Imovel = () => {
  const { codigo } = useParams();
  const { favorites, addFavorite, removeFavorite } = useFavorites();
  const [imovel, setImovel] = useState(null);
  const [corretor, setCorretor] = useState(null);
  const [activeTab, setActiveTab] = useState("características");
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [bookTecnicoURL, setBookTecnicoURL] = useState("");
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const previousUrlRef = useRef(null);
  const watermarkRequestedRef = useRef(false);
  const swiperRef = useRef(null);

  const nextImage = () => {
    if (!imagesLinks) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === imagesLinks.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    if (!imagesLinks) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? imagesLinks.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isLightboxOpen) return;

      if (e.key === "ArrowRight") {
        nextImage();
      } else if (e.key === "ArrowLeft") {
        prevImage();
      } else if (e.key === "Escape") {
        closeLightbox();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isLightboxOpen, currentImageIndex]);

  useEffect(() => {

    const fetchImovel = async () => {

      try {
        const snapshot = await get(ref(db, "imoveisPublicos/"));
        if (snapshot.exists()) {
          const imoveis = snapshot.val();
          const imovelEncontrado = Object.values(imoveis).find(
            (item) => item.imovelInfo.codigo === codigo
          );

          if (imovelEncontrado) {

            if (imovelEncontrado.bookTecnicoURL) {
              setBookTecnicoURL(imovelEncontrado.bookTecnicoURL);
            }

            setImovel(imovelEncontrado);

            // Busca informações do corretor
            const corretorSnapshot = await get(
              ref(db, `corretores/${imovelEncontrado.imovelInfo.corretor}`)
            );

            if (corretorSnapshot.exists()) {
              setCorretor(corretorSnapshot.val());
            }
          }
        }
      } catch (error) {
        console.error("Erro ao buscar imóvel:", error);
      }
    };

    fetchImovel();
  }, [codigo]);

  useEffect(() => {
    if (!imovel) return;
    if (watermarkRequestedRef.current) return;
    if (imovel.watermarked === true) return;

    const imovelId = imovel.id;
    if (!imovelId) return;

    watermarkRequestedRef.current = true;

    requestImovelWatermark({ imovelId }).catch((error) => {
      console.error("Erro ao solicitar marca d'água:", error);
    });
  }, [imovel]);

  useEffect(() => {
    if (!imovel) return;

    const isLocalDevelopment =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    // Em desenvolvimento local o React dev server não executa PHP: reescrever
    // a URL para /imovel.php quebraria o F5 (o navegador tentaria baixar o
    // arquivo .php) e deixaria a barra de endereço com a URL do backend
    // durante todo o desenvolvimento. Em localhost/127.0.0.1 simplesmente não
    // mexemos na URL — ela já é a rota normal do HashRouter (/#/imovel/{codigo}).
    if (isLocalDevelopment) {
      return;
    }

    const id = imovel.imovelInfo.codigo;

    // ✅ guarda a URL atual ANTES de trocar
    if (!previousUrlRef.current) {
      previousUrlRef.current = window.location.href;
    }

    // Fluxo oficial de compartilhamento: imovel.php busca os dados reais do
    // imóvel no Firebase e gera o Open Graph no servidor.
    const newUrl = `/imovel.php?codigo=${id}`;
    window.history.replaceState(null, "", newUrl);

    return () => {
      const previous = previousUrlRef.current || window.location.href;

      const normalized =
        previous.includes("/#/") || previous.includes("imovel.php")
          ? previous
          : `/#/${previous
            .replace(window.location.origin, "")
            .replace(/^\/+/, "")}`;

      window.history.replaceState(null, "", normalized);
    };
  }, [imovel]);

  const handleDownloadBook = () => {
    if (!bookTecnicoURL) return;
    const link = document.createElement("a");
    link.href = bookTecnicoURL;
    link.setAttribute("download", "Book_Tecnico.pdf");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const backPage = () => {
    window.history.back();
  };

  if (!imovel) {
    return (
      <div className="imovel-page">
        <div className="imovel-page__inner imovel-notfound">
          <button type="button" className="imovel-nav__back" onClick={backPage}>
            <IoArrowBackSharp aria-hidden="true" />
            <span>Voltar</span>
          </button>
          <h1>Imóvel não encontrado</h1>
        </div>
      </div>
    );
  }

  const {
    imovelInfo = {},
    caracteristicas = {},
    informacoesComerciais = {},
    selectedItems = [],
    imagesLinks = [],
  } = imovel || {};

  const showWatermarkOverlay = imovel?.watermarked !== true;

  const isFavoriteImovel = favorites.some(
    (fav) => fav.imovelInfo.codigo === imovelInfo.codigo
  );

  const toggleFavoriteImovel = () => {
    if (isFavoriteImovel) {
      removeFavorite(imovelInfo.codigo);
    } else {
      addFavorite(imovel);
    }
  };

  // Mesma URL pública oficial de compartilhamento gerada por imovel.php
  // (ver public/imovel.php) — evita criar uma rota paralela.
  const shareUrl = `https://sennaviannini.com.br/imovel.php?codigo=${imovelInfo.codigo}`;

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const caracteristicasFiltradas = Object.entries(caracteristicas || {}).filter(
    ([_, valor]) =>
      valor !== 0 &&
      valor !== "0" &&
      valor !== "false" &&
      valor !== false &&
      valor !== "" &&
      valor !== null &&
      valor !== undefined
  );

  const tabContent = {
    características: (
      <div className="caracteristicasStyle">
        {caracteristicasFiltradas.length > 0 ? (
          <div className="imovel-feature-grid">
            {caracteristicasFiltradas.map(([key, valor], index) => {
              const icons = {
                areaTerreno: (
                  <FaRulerCombined className="iconListCaracteristicas" />
                ),
                areaConstruida: (
                  <FaRulerCombined className="iconListCaracteristicas" />
                ),
                banheiros: <FaBath className="iconListCaracteristicas" />,
                lavabos: <FaFaucetDrip className="iconListCaracteristicas" />,
                suites: <FaBath className="iconListCaracteristicas" />,
                quartos: <FaBed className="iconListCaracteristicas" />,
                vagas: <FaCar className="iconListCaracteristicas" />,
                frente: <FaHouseDamage className="iconListCaracteristicas" />,
                fundos: <FaHouseDamage className="iconListCaracteristicas" />,
                lateralDireita: (
                  <FaRulerCombined className="iconListCaracteristicas" />
                ),
                lateralEsquerda: (
                  <FaRulerCombined className="iconListCaracteristicas" />
                ),
                posicao: (
                  <FaLocationArrow className="iconListCaracteristicas" />
                ),
                sacadas: (
                  <PiHouseLineFill className="iconListCaracteristicas" />
                ),
                salas: <FaTv className="iconListCaracteristicas" />,
                varanda: (
                  <PiHouseLineFill className="iconListCaracteristicas" />
                ),
                pavimentos: <FaBuilding className="iconListCaracteristicas" />,
                cozinha: <FaKitchenSet className="iconListCaracteristicas" />,
                comodos: <FaDoorClosed className="iconListCaracteristicas" />,
                areaServico: <GiBroom className="iconListCaracteristicas" />,
                copas: <GiTable className="iconListCaracteristicas" />,
                areaPrivativa: (
                  <MdOutdoorGrill className="iconListCaracteristicas" />
                ),
              };

              return (
                <div className="imovel-feature" key={index}>
                  {icons[key] || (
                    <RiCheckboxBlankCircleFill className="iconListCaracteristicas" />
                  )}
                  <p>
                    {key === "areaConstruida"
                      ? `${valor} m² área construída`
                      : key === "areaTerreno"
                        ? `${valor} m² área do terreno`
                        : key === "areaPrivativa"
                          ? `${valor} área privativa`
                          : key === "areaServico" || key === "areasServico"
                            ? `${valor} área de serviço`
                            : key === "areaGourmet"
                              ? "Área gourmet"
                              : (() => {
                                const nomeFormatado = key
                                  .replace(/([A-Z])/g, " $1")
                                  .replace("area", "área")
                                  .toLowerCase();

                                if (
                                  parseInt(valor) === 1 &&
                                  nomeFormatado.endsWith("s")
                                ) {
                                  return `1 ${nomeFormatado.slice(0, -1)}`; // remove o "s" do final
                                } else {
                                  return `${valor} ${nomeFormatado}`;
                                }
                              })()}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          <p>Nenhuma característica disponível</p>
        )}
      </div>
    ),
    atributos: (
      <div className="atributosStyle">
        {selectedItems.length > 0 ? (
          <div className="imovel-feature-grid">
            {selectedItems.map((atributo, index) => (
              <div className="imovel-feature" key={index}>
                <RiCheckboxBlankCircleFill className="iconListAtributos" />
                <p>{atributo}</p>
              </div>
            ))}
          </div>
        ) : (
          <p>Nenhum atributo disponível</p>
        )}
      </div>
    ),
    descrição: (
      <div className="descricaoStyle">
        <p className="imovel-description">
          {imovelInfo?.descricao || "Descrição não disponível."}
        </p>
      </div>
    ),
  };

  const handleLocationClick = () => {
    if (imovel?.informacoesAdicionais?.linkLocalizacao) {
      window.open(imovel.informacoesAdicionais.linkLocalizacao, "_blank");
    } else {
      alert("Localização indisponível para este imóvel.");
    }
  };

  return (
    <div className="imovel-page">
      <div className="imovel-page__inner">
        <div className="imovel-nav">
          <button type="button" className="imovel-nav__back" onClick={backPage}>
            <IoArrowBackSharp aria-hidden="true" />
            <span>Voltar</span>
          </button>
        </div>

        <header className="imovel-hero">
          <div className="imovel-hero__heading">
            <p className="imovel-hero__meta">
              {[
                imovelInfo.tipo,
                `Cód. ${imovelInfo.codigo}`,
                [imovelInfo.bairro, imovelInfo.cidade].filter(Boolean).join(", "),
              ]
                .filter(Boolean)
                .join(" · ")}
            </p>
            <h1 className="imovel-hero__title">{imovelInfo.titulo}</h1>
          </div>

          <div className="imovel-hero__commercial">
            <div className="imovel-hero__price">
              <span className="imovel-hero__price-value">
                {informacoesComerciais.valor}
              </span>
              {imovelInfo.modalidade && (
                <span className="imovel-hero__badge">{imovelInfo.modalidade}</span>
              )}
            </div>
            <button
              type="button"
              className="imovel-hero__favorite"
              aria-label={
                isFavoriteImovel ? "Remover dos favoritos" : "Adicionar aos favoritos"
              }
              onClick={toggleFavoriteImovel}
            >
              {isFavoriteImovel ? <FaHeart color="var(--verde)" /> : <FaRegHeart />}
            </button>
            <button
              type="button"
              className="imovel-hero__share"
              aria-label="Compartilhar imóvel"
              onClick={() => setIsShareModalOpen(true)}
            >
              <FaShareAlt />
            </button>
          </div>
        </header>

        <div className="imovel-gallery">
          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ type: "fraction" }}
            loop={true}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
            className="imovel-swiper"
          >
            {imagesLinks?.map((image, index) => (
              <SwiperSlide key={index}>
                <button
                  type="button"
                  className="imovel-gallery__slide"
                  onClick={() => openLightbox(index)}
                  aria-label={`Ampliar foto ${index + 1}`}
                >
                  <img
                    src={image}
                    alt={`Foto ${index + 1} do imóvel`}
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding="async"
                  />
                  {showWatermarkOverlay && (
                    <div className="watermark">
                      <img
                        src={WaterMark}
                        alt="Marca d'água"
                        className="watermarkImage"
                      />
                    </div>
                  )}
                </button>
              </SwiperSlide>
            ))}
          </Swiper>

          {imagesLinks.length > 1 && (
            <div className="imovel-gallery__thumbs">
              {imagesLinks.map((image, index) => (
                <button
                  key={index}
                  type="button"
                  className={`imovel-gallery__thumb${activeSlide === index ? " is-active" : ""
                    }`}
                  onClick={() => swiperRef.current?.slideTo(index)}
                  aria-label={`Ver foto ${index + 1}`}
                >
                  <img src={image} alt="" loading="lazy" decoding="async" />
                </button>
              ))}
            </div>
          )}
        </div>

        {bookTecnicoURL && (
          <div className="imovel-book">
            <button type="button" className="imovel-book__button" onClick={handleDownloadBook}>
              <FaFileDownload aria-hidden="true" />
              Baixar Book Técnico (PDF)
            </button>
          </div>
        )}

        {isLightboxOpen && (
          <div className="imovel-lightbox">
            <button
              type="button"
              className="imovel-lightbox__arrow left"
              onClick={prevImage}
              aria-label="Foto anterior"
            >
              <IoIosArrowBack />
            </button>
            <button
              type="button"
              className="imovel-lightbox__arrow right"
              onClick={nextImage}
              aria-label="Próxima foto"
            >
              <IoIosArrowForward />
            </button>
            <button
              type="button"
              className="imovel-lightbox__close"
              onClick={closeLightbox}
              aria-label="Fechar"
            >
              <IoIosClose />
            </button>
            <div className="imovel-lightbox__image-wrapper">
              <img
                src={imagesLinks[currentImageIndex]}
                alt="Imagem ampliada"
                className="imovel-lightbox__image"
              />
              {showWatermarkOverlay && (
                <div className="watermark">
                  <img
                    src={WaterMark}
                    alt="Marca d'água"
                    className="watermarkImage"
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <div className="imovel-content">
          <div className="imovel-content__main">
            <div className="imovel-tabs" role="tablist">
              {Object.keys(tabContent).map((tab) => (
                <button
                  key={tab}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === tab}
                  className={`imovel-tabs__trigger${activeTab === tab ? " is-active" : ""
                    }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
            <div className="imovel-tabs__panel">{tabContent[activeTab]}</div>
          </div>

          <aside className="imovel-content__side">
            <div className="imovel-broker">
              <img
                className="imovel-broker__photo"
                src={corretor?.fotoURL || "https://via.placeholder.com/150"}
                alt={
                  corretor
                    ? `${corretor.nome} ${corretor.sobrenome}`
                    : "Corretor não encontrado"
                }
              />
              <div className="imovel-broker__info">
                <h3 className="imovel-broker__name">
                  {corretor
                    ? `${corretor.nome} ${corretor.sobrenome}`
                    : "Corretor não encontrado"}
                </h3>
                <p className="imovel-broker__creci">
                  CRECI: {corretor?.creci || "Não informado"}
                </p>
                {corretor?.telefone ? (
                  <a
                    className="imovel-broker__whatsapp"
                    href={`https://wa.me/55${corretor.telefone.replace(
                      /\D/g,
                      ""
                    )}?text=Olá,%20vim%20do%20site%20Senna%20Viannini%20e%20tenho%20interesse%20no%20imóvel%20código%20${imovelInfo.codigo
                      }`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp aria-hidden="true" />
                    <span>{corretor.telefone}</span>
                  </a>
                ) : (
                  <p className="imovel-broker__unavailable">
                    Número de contato não disponível
                  </p>
                )}
              </div>
            </div>

            <button type="button" className="imovel-location" onClick={handleLocationClick}>
              <FaMapMarkedAlt className="imovel-location__icon" aria-hidden="true" />
              <span>Ver localização</span>
            </button>
          </aside>
        </div>
      </div>

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        url={shareUrl}
        title={imovelInfo.titulo}
      />
    </div>
  );
};

export default Imovel;
